import { schema } from "normalizr";

export const filter = new schema.Entity(
  "filters",
  {},
  { idAttribute: "id" }
);
